<template>
    <div class="selfEvaluation">
        <div class="main">
            <p class="title">自我评价</p>
            <div v-show="showed"
                 class="selfEvaluation-main">
                <p>{{ruleForm.selfEvaluation}}</p>
                <i class="el-icon-edit-outline"
                   @click="changeshowed()"></i>
            </div>
            <el-form v-show="!showed"
                     :model="ruleForm"
                     :rules="rules"
                     ref="ruleForm"
                     :inline="true"
                     label-position="top"
                     label-width="100px"
                     class="demo-ruleForm">
                <el-form-item label="评价内容"
                              prop="selfEvaluation">
                    <el-input type="textarea"
                              maxlength="200"
                              v-model="ruleForm.selfEvaluation"></el-input>
                </el-form-item>
                <el-form-item v-show="showedbtn"
                              style=" display:block;
                                    text-align:center;
                                    margin:26px 0;">
                    <el-button type="primary"
                               @click="subitselfEvaluation('ruleForm')">保存</el-button>
                    <el-button @click="quxiaoselfEvaluation('ruleForm')">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { saveevaluation, selectevaluation } from "@/api/apiall";
export default {
    data() {
        return {
            showedbtn: false,
            showed: true,
            ruleForm: {
                userId: "",
                id: "",
                selfEvaluation: ""
            },
            rules: {
                selfEvaluation: [
                    {
                        required: true,
                        message: "必填",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    watch: {
        $route(to, from) {
            if (to.path == "/Curriculumvitae") {
                this.showed = true;
                this.showedbtn = true;
            } else {
                this.showed = false;
                this.showedbtn = false;
            }
        }
    },
    created() {
        if (this.$route.path == "/Curriculumvitae") {
            this.showed = true;
            this.showedbtn = true;
        } else {
            this.showed = false;
            this.showedbtn = false;
        }
        // if (
        //     sessionStorage.getItem("userId") != null ||
        //     sessionStorage.getItem("userId") != undefined
        // ) {
        //     this.searchselectevaluation();
        // }
    },
    methods: {
        changeshowed() {
            this.showed = false;
        },
        searchselectevaluation() {
            this.ruleForm.userId = sessionStorage.getItem("userId");
            selectevaluation({ userId: this.ruleForm.userId }).then(res => {
                if (res.status === 2000) {
                    if (res.data) {
                        this.ruleForm = res.data;
                    } else {
                        this.showed = false;
                    }
                } else {
                    this.showed = false;
                }
            });
        },
        subitselfEvaluation(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.ruleForm.id = sessionStorage.getItem("informationId");
                    this.ruleForm.userId = sessionStorage.getItem("userId");
                    saveevaluation(this.ruleForm).then(res => {
                        if (res.status === 2000) {
                            this.$message({
                                message: "提交成功",
                                type: "success"
                            });
                            this.showed = true;
                            this.searchselectevaluation();
                        } else {
                            this.$message({
                                message: res.data,
                                type: "warning"
                            });
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        quxiaoselfEvaluation(formName) {
            this.showed = true;
            this.$refs[formName].resetFields();
            this.searchselectevaluation();
        },
        save() {
            this.$emit("selfEvaluationByValue", this.ruleForm);
        }
    }
};
</script>
<style scoped lang="scss">
.selfEvaluation {
    width: 900px;
    background-color: #fff;
    float: left;
    .main {
        padding: 30px;
        border-bottom: 1px solid #ddd;
        .selfEvaluation-main {
            position: relative;
            p {
                width: 90%;
                font-size: 14px;
                color: #666;
                margin-top: 28px;
                margin-bottom: 16px;
                line-height: 22px;
            }
            .el-icon-edit-outline {
                cursor: pointer;
                font-size: 25px;
                color: #fabe00;
                position: absolute;
                right: 0px;
                bottom: 0px;
            }
        }
        .title {
            font-size: 18px;
            color: #333;
            .add {
                cursor: pointer;
                float: right;
                color: #fabe00;
                font-size: 15px;
            }
        }
        .sign {
            display: inline-block;
            margin-left: 12px;
            position: relative;
            top: -2px;
            width: 37px;
            height: 18px;
            color: #fff;
            background-color: #fabe00;
            text-align: center;
            line-height: 16px;
            font-size: 12px;
            border-radius: 4px;
        }
        .el-form {
            margin-top: 20px;
            margin-bottom: 20px;
            .el-input,
            .el-select {
                width: 230px;
            }
            h3 {
                font-size: 17px;
                margin: 20px 0;
                font-weight: 500;
            }
            .el-date-editor {
                width: 105px;
                /deep/ .el-input__inner {
                    padding-right: 0;
                }
            }
            .el-textarea {
                width: 740px;
            }
            /deep/ .el-form-item {
                margin-bottom: 6px !important;
                .el-form-item__label {
                    padding: 0 !important;
                }
            }
        }
        .el-form--label-top .el-form-item__label {
            padding: 0;
        }
        .el-form--inline .el-form-item {
            margin-right: 30px;
        }
        .center {
            position: relative;
            left: 50%;
            transform: translateX(-50%);
        }
    }
}
</style>
